<div class="mat-app-background" style="height: 100%">
  <mat-card appearance="raised">
    <mat-progress-bar class="progress-loader"
                      [mode]="loadingIndicator ? 'indeterminate' : 'determinate'" value="0"
                      color="primary"></mat-progress-bar>
    <mat-card-content class="header-card">
      <div class="control-panel-container">
        <div class="control-panel-header">
          <h1>Error!</h1>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card appearance="raised" class="overview-panel">
    <mat-card-content>
      <p>There is an error! Please return back to the main page of the application.</p>
      <a routerLink="/" style="color: inherit">Click here to return to the main page.</a>
    </mat-card-content>
  </mat-card>
</div>

